import React from "react";
import { ChildrenProps, ClassNameProps, makeClassName, StyleProps } from "@hex-insights/core";
import { IconContext, IconProps } from "@phosphor-icons/react";
import styles from "./styles.module.css";

export * as Icon from "@phosphor-icons/react";

const baseIconContextValue: IconProps = { size: 32, weight: "bold", className: styles["icon"] };

export type BaseIconContextProviderProps = Partial<ChildrenProps>;

export function BaseIconContextProvider({ children }: BaseIconContextProviderProps) {
	return <IconContext.Provider value={baseIconContextValue}>{children}</IconContext.Provider>;
}

export type IconContainerProps = {
	color?: string;
} & Partial<ClassNameProps & StyleProps & ChildrenProps>;

export function IconContainer({ color, className, style, children }: IconContainerProps) {
	return (
		<div
			className={makeClassName(styles["icon-container"], className)}
			style={{ "--background-color": color, ...style } as React.CSSProperties}
		>
			{children}
		</div>
	);
}
